var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1051,
    height: 279,
    viewBox: "0 0 1051 279",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M900.65 235.46L887.95 240.903L900.65 246.345L906.093 259.045L911.536 246.345L924.236 240.903L911.536 235.46L906.093 222.76L900.65 235.46Z",
    stroke: "#D89F5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.904 253.414L72.2041 258.857L84.904 264.3L90.3469 277L95.7897 264.3L108.49 258.857L95.7897 253.414L90.3469 240.714L84.904 253.414Z",
    stroke: "#D89F5B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M814.701 14.6999L802.001 20.1428L814.701 25.5856L820.144 38.2855L825.587 25.5856L838.286 20.1428L825.587 14.6999L820.144 2L814.701 14.6999Z",
    stroke: "#D89F5B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6999 126.494L2 131.937L14.6999 137.38L20.1428 150.08L25.5856 137.38L38.2855 131.937L25.5856 126.494L20.1428 113.794L14.6999 126.494Z",
    stroke: "#D89F5B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1026.07 104.407L1013.37 109.85L1026.07 115.293L1031.51 127.993L1036.96 115.293L1049.66 109.85L1036.96 104.407L1031.51 91.7075L1026.07 104.407Z",
    stroke: "#D89F5B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M275.009 19.0578L262.309 24.5007L275.009 29.9435L280.451 42.6434L285.894 29.9435L298.594 24.5007L285.894 19.0578L280.451 6.35791L275.009 19.0578Z",
    stroke: "#D89F5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarts);
export default __webpack_public_path__ + "static/media/starts.ccb507debca698a11409e35a7ba70fbf.svg";
export { ForwardRef as ReactComponent };